var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teachers-main"},[_c('PageTop',{staticClass:"bg-gray",attrs:{"page":"teachers"}}),_c('img',{staticClass:"teachers-banner",attrs:{"src":require("@/assets/image/teacher-img.png")}}),_c('TeachersForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }